// Parameters from erros. Used to parse translate variables
export const ERROR_CODE_PARAMETERS = {
    maxLineCount: 10000,
    maxFileSize: 20971520,
    maxFileSizeFormat: '20MB',
};
// Error when a line has a odd double quotes count
export const INVALID_DOUBLE_QUOTES_COUNT = 'AC01';
// Error when column values after column 1 is required but is not present.
export const COLUMN_VALUE_REQUIRED = 'AC02';
// Error when the first column is empty
export const FIRST_COLUMN_EMPTY = 'AC03';
// Error when the column has an invalid phone number
export const INVALID_PHONE_NUMBER = 'AC04';
// Error when file encoding is not UTF8
export const INVALID_ENCODING = 'AC05';
// Error when file has exceeded the maximum number of lines allowed.
export const MAX_LINES_NUMBER_EXCEEDED = 'AC06';
// Error when file´s header has duplicate column..
export const HAS_DUPLICATED_COLUMN = 'AC07';
// Error when file has no header on first line.
export const HAS_NO_HEADER = 'AC08';
// Error when  header has an odd number of double quotes.
export const HEADER_INVALID_DOUBLE_QUOTES_COUNT = 'AC09';
// Error when header column name has null value.
export const HEADER_HAS_NULL_VALUE = 'AC10';
// Error when line and header column count do not match
export const LINE_AND_HEADER_COLUMN_COUNT_DO_NOT_MATCH = 'AC11';
// Error when all phone numbers are invalid
export const ALL_INVALID_PHONE_NUMBERS = 'AC12';
// Error when file size exceded the maximum allowed
export const MAX_FILE_SIZE = 'maxFileSize';
// Error when the attendant does not exists in the bot
export const INEXISTENT_ATTENDENT = '1501';
// Error when the attendant exists in the bot but it is not active
export const INACTIVE_ATTENDENT = '1502';
// List of errors count to be processed
export const FIELD_ERROR_TO_ALERT = [
    'linesBlankCount',
    'linesErrorsCount',
    'linesRepeatCount',
];
// Error when message template variables count and file columns count do not match
export const VARIABLES_COUNT_ERROR = 'variblesCountError';
// Enums of batch content error types
export var BATCH_CONTENT_ERROR_TYPES;
(function (BATCH_CONTENT_ERROR_TYPES) {
    BATCH_CONTENT_ERROR_TYPES["TextVariableError"] = "textVariableError";
    BATCH_CONTENT_ERROR_TYPES["ButtonVariableError"] = "buttonVariableError";
    BATCH_CONTENT_ERROR_TYPES["MediaFieldError"] = "mediaFieldError";
    BATCH_CONTENT_ERROR_TYPES["GeneralError"] = "generalError";
    BATCH_CONTENT_ERROR_TYPES["Information"] = "information";
})(BATCH_CONTENT_ERROR_TYPES || (BATCH_CONTENT_ERROR_TYPES = {}));
